var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "mdkqk4ftea"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 0.176471 0 0 0 0 0.333333 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#mdkqk4ftea)",
    transform: "translate(-867 -609)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M37.339 35.026c0 .964-.782 1.745-1.745 1.745H16.409c-.963 0-1.744-.78-1.744-1.745 0-.962.78-1.744 1.744-1.744h19.186c.963 0 1.744.782 1.744 1.744zm1.02-19.713c.616.617.616 1.616 0 2.232l-4.742 4.742c-.616.616-1.617.616-2.232 0-.616-.616-.616-1.616 0-2.232l4.742-4.741c.616-.617 1.616-.617 2.232 0zm.103 8.165c0 1.13-.916 2.046-2.046 2.046-1.129 0-2.045-.916-2.045-2.046s.916-2.046 2.045-2.046c1.13 0 2.046.916 2.046 2.046zm-24.82-5.933c-.616-.616-.616-1.615 0-2.232.616-.616 1.616-.616 2.232 0l4.742 4.742c.616.616.616 1.615 0 2.232-.616.616-1.616.616-2.232 0l-4.741-4.742zm1.943 7.98c-1.13 0-2.046-.917-2.046-2.047 0-1.13.916-2.046 2.046-2.046 1.129 0 2.045.916 2.045 2.046s-.916 2.046-2.045 2.046zM42.859 52H9.142C4.102 52 0 47.899 0 42.859V9.142C0 4.1 4.102 0 9.142 0h33.716C47.9 0 52 4.101 52 9.142v33.716C52.001 47.899 47.9 52 42.86 52zM9.142 4.302c-2.669 0-4.84 2.171-4.84 4.84v33.716c0 2.668 2.171 4.84 4.84 4.84h33.716c2.669 0 4.84-2.172 4.84-4.84V9.142c0-2.669-2.171-4.84-4.84-4.84H9.142z",
    transform: "translate(867 609)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnger);
export default __webpack_public_path__ + "static/media/anger.d9dc74bd2360ab23d4fc06fa5dab8980.svg";
export { ForwardRef as ReactComponent };